module.exports = __webpack_public_path__ + "static/img/gerenzhongxin.c73009a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gerenzhongxin.png
// module id = ReMF
// module chunks = 52